(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["design-portal-quote-product-page"] && !Shopify.designMode) return;
  try {
    const DESIGN_PORTAL_STORAGE_KEY = 'designPortalQuote';

  function mergeQuoteItems(existingItems, newItem) {
    const itemsByVariant = new Map();

    (existingItems || []).forEach((item) => {
      if (!item || !item.variantId) return;
      itemsByVariant.set(String(item.variantId), item);
    });

    if (newItem && newItem.variantId && newItem.quantity > 0) {
      const key = String(newItem.variantId);
      const existing = itemsByVariant.get(key);

      if (existing) {
        const quantity = existing.quantity + newItem.quantity;
        const unitPrice = typeof existing.unitPrice === 'number'
          ? existing.unitPrice
          : newItem.unitPrice;

        itemsByVariant.set(key, {
          ...existing,
          quantity,
          unitPrice,
          lineTotal: quantity * unitPrice,
        });
      } else {
        itemsByVariant.set(key, {
          ...newItem,
          lineTotal: newItem.quantity * newItem.unitPrice,
        });
      }
    }

    return Array.from(itemsByVariant.values());
  }

  function safeReadExistingQuote() {
    try {
      const raw = window.localStorage.getItem(DESIGN_PORTAL_STORAGE_KEY);
      if (!raw) return null;

      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return null;

      if (!Array.isArray(parsed.items)) {
        parsed.items = [];
      }

      return parsed;
    } catch (error) {
      return null;
    }
  }

  function writeMergedQuote(newItem) {
    const existing = safeReadExistingQuote();

    const baseQuote = existing || {
      projectName: '',
      reservationUntil: '',
      designerName: '',
      designerEmail: '',
      currency: '',
      items: [],
      totalPrice: 0,
    };

    const mergedItems = mergeQuoteItems(baseQuote.items, newItem);

    const mergedTotal = mergedItems.reduce((sum, item) => {
      if (!item || typeof item.lineTotal !== 'number') return sum;
      return sum + item.lineTotal;
    }, 0);

    const mergedQuote = {
      ...baseQuote,
      items: mergedItems,
      totalPrice: mergedTotal,
    };

    try {
      window.localStorage.setItem(
        DESIGN_PORTAL_STORAGE_KEY,
        JSON.stringify(mergedQuote),
      );
    } catch (error) {
    }
  }

  window.addCurrentProductToDesignQuote = function addCurrentProductToDesignQuote(options) {
    if (!options || !options.variantId) {
      return;
    }

    const quantity = Math.max(1, Number(options.quantity || 1));
    const unitPrice = Number(options.unitPrice || 0);

    const newItem = {
      variantId: String(options.variantId),
      productTitle: options.productTitle || '',
      variantTitle: options.variantTitle || '',
      quantity: quantity,
      unitPrice: unitPrice,
      lineTotal: quantity * unitPrice,
      imageUrl: options.imageUrl || null,
      productUrl: options.productUrl || '',
    };

    writeMergedQuote(newItem);
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-add-to-cart"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-action="add-to-quote"]');
    if (!button) return;

    var form = button.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;

    var variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;

    var variantId = variantInput.value;
    if (!variantId) return;

    var productFormElement = button.closest('product-form');
    if (!productFormElement) {
      button.setAttribute('data-variant-id', variantId);
      return;
    }

    var productDataRaw = productFormElement.getAttribute('data-product');
    var productData = null;

    if (productDataRaw) {
      try {
        productData = JSON.parse(productDataRaw);
      } catch (e) {
        productData = null;
      }
    }

    var variantData = null;

    if (productData && Array.isArray(productData.variants)) {
      for (var i = 0; i < productData.variants.length; i++) {
        if (String(productData.variants[i].id) === String(variantId)) {
          variantData = productData.variants[i];
          break;
        }
      }
    }

    button.setAttribute('data-variant-id', variantId);

    if (variantData) {
      if (variantData.title) {
        button.setAttribute('data-variant-title', variantData.title);
      }

      if (typeof variantData.price !== 'undefined') {
        button.setAttribute('data-price', variantData.price);
      }

      if (!button.hasAttribute('data-image-url')) {
        if (variantData.featured_image && variantData.featured_image.src) {
          button.setAttribute('data-image-url', variantData.featured_image.src);
        } else if (productData && productData.featured_image && productData.featured_image.src) {
          button.setAttribute('data-image-url', productData.featured_image.src);
        }
      }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
